import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Service } from './delete-policy.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'delete-policy',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./delete-policy.scss')],
  template: require('./delete-policy.html')
})

export class DeletePolicy {
  @Input('isVisible') isVisible: boolean;
  @Input('mode') mode: string;
  @Input('selectedObject') selectedObject;
  @Input('selectedVDC') selectedVDC;
  @Output('onClose') selfClose = new EventEmitter();

  private subscribeHandler;
  private submitted: boolean = false;
  private active: boolean = true;
  private description2 = "";
  private isRequestPending: boolean = false;

  constructor(public service: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  onSubmit() {
    switch(this.mode){
      case DataProtectionVariables.MODES['VAPP']:
        this.deleteVapp();
        break;
      case DataProtectionVariables.MODES['VDC']:
        this.deleteVDC();
        break;
      default :
        this.deleteVapp();
    }
  }

  onSubmitButtonClicked(f: NgForm) {
  }

  onCancelButtonClicked() {
    this.closeSelf();
  }

  //Life Cycle Hooks
  ngOnInit() {
  }

  ngOnChanges(changes) {
    if(this.mode && changes && changes.hasOwnProperty('selectedObject') && changes.selectedObject && changes.selectedObject.hasOwnProperty('currentValue')
      && changes.selectedObject.currentValue && this.mode === DataProtectionVariables.MODES['VAPP'] ) {
        this.description2 = this.translate.instant('dpsModule.deletePolicy.vapp.description2');
    }

    if(this.mode && changes && changes.hasOwnProperty('selectedVDC') && changes.selectedVDC && changes.selectedVDC.hasOwnProperty('currentValue')
      && changes.selectedVDC.currentValue && this.mode === DataProtectionVariables.MODES['VDC'] ) {
        this.description2 = this.translate.instant('dpsModule.deletePolicy.vdc.description2');
    }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if(this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  deleteVapp() {
    if(this.selectedVDC && this.selectedVDC.id !== '' &&
       this.selectedObject && this.selectedObject[0] && this.selectedObject[0].id && this.selectedObject[0].id !== '') {
          this.isRequestPending = true;
          this.subscribeHandler = this.service.deleteVapp(this.selectedVDC.id, this.selectedObject[0].id)
            .subscribe(
              res => {
                this.closeSelf();
              },
              error => this.logError(error, 'delete vApp'),
              () => this.logOperationCompleted('delete vApp')
            );
    }
    else
      this.logError('Incorrect VDC or vApp information');
  }

  deleteVDC() {
    if(this.selectedVDC && this.selectedVDC.id !== '') {
      this.isRequestPending = true;
      this.subscribeHandler = this.service.deleteVDC(this.selectedVDC.id)
        .subscribe(
          res => {
            this.closeSelf();
          },
          error => this.logError(error, 'delete VDC'),
          () => this.logOperationCompleted('delete VDC')
        );
    }
    else
      this.logError('Incorrect VDC information');
  }

  closeSelf() {
    if (this.selfClose) {
      this.selfClose.emit({
        value: "close"
      });
    }
  }


  logError(error, origin:String = '') {
    this.isRequestPending = false;
    console.error('Error: ', error, (origin !== '')? " Error from " + origin : "");
  }

  logOperationCompleted(msg: string) {
    this.isRequestPending = false;
    console.log('Operation Completed: ', msg);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/delete-policy/delete-policy.component.ts